(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Accordion = /** @class */ (function () {
    function Accordion() {
        var _this = this;
        /**
         * @desc func for closing other accordions in same group
         */
        this.initAccordionGroup = function () {
            var accordions = Array.from(document.querySelectorAll('details'));
            accordions.forEach(function (accordion) {
                accordion.querySelector('summary').addEventListener('click', function () {
                    if (accordion.getAttribute('data-group')) {
                        var accordionGroupIndicator = accordion.getAttribute('data-group'), accordionGroup = Array.from(document.querySelectorAll('details[data-group="' + accordionGroupIndicator + '"]'));
                        accordionGroup.forEach(function (item) {
                            if (item !== accordion) {
                                item.removeAttribute('open');
                            }
                        });
                    }
                });
            });
        };
        /**
         * @desc fallback func for IE
         */
        this.initAccordionIeFallback = function () {
            if (_this.msIeVersion()) {
                var accordions = Array.from(document.querySelectorAll('details'));
                accordions.forEach(function (accordion) {
                    if (accordion.getAttribute('open')) {
                        accordion.setAttribute('aria-expanded', 'true');
                    }
                    else {
                        accordion.setAttribute('aria-expanded', 'false');
                    }
                    accordion.querySelector('summary').addEventListener('click', function () {
                        if (accordion.getAttribute('open')) {
                            accordion.removeAttribute('open');
                            accordion.setAttribute('aria-expanded', 'false');
                        }
                        else {
                            accordion.setAttribute('open', '');
                            accordion.setAttribute('aria-expanded', 'true');
                        }
                    });
                });
            }
        };
        this.msIeVersion = function () {
            var ua = window.navigator.userAgent, msie = ua.indexOf('MSIE ');
            if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
                console.log(parseInt(ua.substring(msie + 5, ua.indexOf('.', msie))));
                return true;
            }
            return false;
        };
        this.initAccordionGroup();
        this.initAccordionIeFallback();
    }
    return Accordion;
}());
exports.default = Accordion;

},{}],2:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Credits = /** @class */ (function () {
    function Credits() {
        this.initClickEvents();
    }
    Credits.prototype.initClickEvents = function () {
        var _this = this;
        var links = Array.from(document.querySelectorAll('.credits a'));
        links.forEach(function (link) {
            link.addEventListener('click', _this.linkClickedHandler);
        });
    };
    Credits.prototype.linkClickedHandler = function (event) {
        var link = event.target, image = document.querySelector('[src="' + link.href + '"],[href="' + link.href + '"]');
        if (image != null) {
            image.scrollIntoView(false);
            event.preventDefault();
        }
    };
    return Credits;
}());
exports.default = Credits;

},{}],3:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Accordion_1 = require("../Hbs/modules/accordion/Accordion");
var Credits_1 = require("../Hbs/modules/credits/Credits");
var Default = /** @class */ (function () {
    function Default() {
        this.burgerToggle();
        this.searchToggle();
        new Accordion_1.default();
        new Credits_1.default();
    }
    Default.prototype.searchToggle = function () {
        var toggleElement = document.querySelector('.search-toggle'), searchInput = document.querySelector('#search-input'), searchSubmit = document.querySelector('#search-submit');
        toggleElement.addEventListener('click', function (event) {
            event.preventDefault();
            toggleElement.classList.toggle('active');
            searchInput.classList.toggle('animate-in');
            searchSubmit.classList.toggle('animate-in');
        });
    };
    Default.prototype.burgerToggle = function () {
        var burger = document.querySelector('.menu-toggle'), header = document.querySelector('header');
        if (burger) {
            burger.addEventListener('click', function () {
                burger.classList.toggle('burger');
                burger.classList.toggle('times');
                header.classList.toggle('active');
            });
        }
    };
    return Default;
}());
new Default();
exports.default = Default;

},{"../Hbs/modules/accordion/Accordion":1,"../Hbs/modules/credits/Credits":2}]},{},[3])

